import type {
  FooterColumnCustomComponent,
  FooterColumnLink,
  FooterColumnStoreLink,
  FooterColumnStoreLinkGroup,
} from '../types'
import { DeviceType } from '@/tools/device-type/types'

function createLink(label: string, href: string): FooterColumnLink {
  return {
    label,
    href,
    type: 'link',
  }
}

function createCustomComponent(component: React.FC): FooterColumnCustomComponent {
  return {
    component,
    type: 'customComponent',
  }
}

function createStoreLink(
  href: string,
  img: string,
  widthPx: number,
  heightPx: number,
  deviceType: Omit<DeviceType, 'UNKNOWN'>
): FooterColumnStoreLink {
  return {
    href,
    img,
    widthPx,
    heightPx,
    type: 'storeLink',
    deviceType,
  }
}

function createStoreLinkGroup(
  storeLinks: FooterColumnStoreLink[],
  currentType: DeviceType
): FooterColumnStoreLinkGroup {
  return {
    storeLinks: storeLinks.filter(
      ({ deviceType }) => currentType === DeviceType.UNKNOWN || deviceType === currentType
    ) as FooterColumnStoreLink[],
    type: 'storeLinkGroup',
  }
}

const instagramHandleOverrides = new Map<string, string>()
  .set('ng', 'glovoapp_ng')
  .set('pt', 'glovo_prt')
  .set('rs', 'glovo_srbija')

function createInstagramLink(country: string | undefined): FooterColumnLink | null {
  if (!country) {
    return null
  }

  const instagramHandle = instagramHandleOverrides.get(country) || `glovo_${country}`

  return createLink('Instagram', `https://www.instagram.com/${instagramHandle}/`)
}

const countriesWithTikTok = ['am', 'bg', 'hr', 'it', 'kz', 'ma', 'ng', 'pl', 'pt', 'ro', 'rs', 'ug']

const tikTokHandleOverrides = new Map<string, string>()
  .set('am', 'glovoarmenia')
  .set('hr', 'glovo_croatia')
  .set('kz', 'glovo_kazakhstan')
  .set('ng', 'glovo.nigeria')

function createTikTokLink(country: string | undefined): FooterColumnLink | null {
  if (!country) {
    return null
  }

  if (!countriesWithTikTok.includes(country)) {
    return null
  }

  const tikTokHandle = tikTokHandleOverrides.get(country) || `glovo_${country}`

  return createLink('TikTok', `https://www.tiktok.com/@${tikTokHandle}/`)
}

export {
  createLink,
  createStoreLink,
  createStoreLinkGroup,
  createInstagramLink,
  createTikTokLink,
  createCustomComponent,
}
